import { createFileRoute } from '@tanstack/react-router'
import { GoldPricing } from '@/features/gold-pricing'

export const Route = createFileRoute('/_authenticated/gold-pricing/')({
  component: GoldPricing,
})
